module.exports = __webpack_public_path__ + "e60bb8cb2e6f2f5d53c6802514f39fa1.svg";